import { useMutation } from '@tanstack/react-query';

import {
  requestOwnTelegramPrivacyOperation,
  waitForOwnTelegramPrivacyExport,
} from '../api/telegram-privacy.client.js';

export function useTelegramPrivacyOperation() {
  return useMutation({
    mutationFn: async (input: { kind: 'export' | 'delete' }) =>
      requestOwnTelegramPrivacyOperation(input.kind),
  });
}

export function useTelegramPrivacyExportDownload() {
  return useMutation({ mutationFn: waitForOwnTelegramPrivacyExport });
}
